/**
 * Resolves the visitor's language on the server so the SSR HTML is already
 * in the right language (no hydration mismatch). Order: explicit choice cookie
 * `ym_lang` → Accept-Language → Spanish.
 */
import { createServerFn } from "@tanstack/react-start";
import { getCookie, getRequestHeader } from "@tanstack/react-start/server";

const SUPPORTED = ["es", "ca", "en"] as const;
export type Lang = (typeof SUPPORTED)[number];

export const getRequestLang = createServerFn({ method: "GET" }).handler(async (): Promise<Lang> => {
  const cookie = getCookie("ym_lang");
  if (cookie && (SUPPORTED as readonly string[]).includes(cookie)) return cookie as Lang;
  const header = getRequestHeader("accept-language") ?? "";
  const ranked = header
    .split(",")
    .map((part) => {
      const [tag, ...params] = part.trim().split(";");
      const q = params.find((p) => p.trim().startsWith("q="));
      return { code: tag.toLowerCase().split("-")[0], q: q ? Number(q.split("=")[1]) || 0 : 1 };
    })
    .filter((x) => x.code)
    .sort((a, b) => b.q - a.q);
  for (const { code } of ranked) {
    if ((SUPPORTED as readonly string[]).includes(code)) return code as Lang;
  }
  return "es";
});
